module.exports = __webpack_public_path__ + "img/39.59221117.jpeg";